export default __webpack_public_path__ + "static/media/cigarette.75cf80a7.png";